import React from 'react';

const NoResultsIcon: React.FC = () => (
  <svg
    width="62"
    height="61"
    viewBox="0 0 62 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    aria-hidden="true"
  >
    <path
      d="M21.98 42.71C33.4289 42.71 42.71 33.4289 42.71 21.98C42.71 10.5311 33.4289 1.25 21.98 1.25C10.5311 1.25 1.25 10.5311 1.25 21.98C1.25 33.4289 10.5311 42.71 21.98 42.71Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.87 17.25L17.25 27.88"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 17.25L27.87 27.88"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.7012 37.0195L40.751 40.75"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6037 39.8605L39.89 41.6531C39.1191 42.4596 39.1479 43.7382 39.9543 44.5091L54.8449 58.7439C55.6514 59.5148 56.93 59.486 57.7009 58.6796L59.4146 56.8869C60.1855 56.0805 60.1567 54.8018 59.3503 54.0309L44.4597 39.7962C43.6532 39.0253 42.3746 39.0541 41.6037 39.8605Z"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NoResultsIcon;
